import angular from 'angular';

class envelopeRouteCtrl {
  /* @ngInject */
  constructor($state, $translate, $sessionStorage, toastr, i18nService, CompanyService) {
    this.$state = $state;
    this.$translate = $translate;
    this.$sessionStorage = $sessionStorage;
    this.toastr = toastr;
    this.i18nService = i18nService;
    this.CompanyService = CompanyService;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());

    if (!this.keepFilter) {
      this.$sessionStorage.envelopeHistorySearchCriteria = null;
      this.$sessionStorage.envelopeHistorySearchCriteriaBis = null;
      this.$sessionStorage.resumptionHistorySearchCriteria = null;
      this.$sessionStorage.resumptionHistorySearchCriteriaBis = null;
      this.$sessionStorage.waitingHistorySearchCriteria = null;
      this.$sessionStorage.waitingHistorySearchCriteriaBis = null;
    }

    // Nom de l'onglet actif
    this.activeTabName = this.activeTab.tabName;

    // Fournit aux onglets l'indication d'utiliser des critères de recherche spécifiques
    if (this.activeTabName === 'resumption') {
      this.specificFormResumption = this.specificForm;
    } else {
      this.specificFormEnvelope = this.specificForm;
    }

    this.tabs = {
      resumption: false
    };

    this.activeTabIndex = 0;

    // Initialise l'état initial des onglets
    this.updateTabStatus();
  }

  // Change l'onglet actif
  selectTab(tabName) {
    if (this.activeTabName === tabName) return;
    this.activeTabName = tabName;
    this.$state.go('envelopes', { tabName: tabName, specificForm: null, keepFilter: true });
    this.updateTabStatus();
  }

  updateTabStatus() {
    this.tabs.envelope = false;
    this.tabs.resumption = false;
    this.tabs.waiting = false;
    if (this.activeTabName === 'resumption') {
      this.activeTabIndex = 1;
    } else if (this.activeTabName === 'waiting') {
      this.activeTabIndex = 2;
    } else {
      this.activeTabIndex = 0;
    }
  }

  selectTabEnvelope() {
    this.selectTab('search');
  }

  selectTabResumption() {
    this.selectTab('resumption');
  }

  selectTabWaiting() {
    this.selectTab('waiting');
  }
}

angular.module('dashboard').component('envelopeRoute', {
  templateUrl: require('./envelope-route.html'),
  controller: envelopeRouteCtrl,
  bindings: {
    activeTab: '<',
    specificForm: '<',
    keepFilter: '<'
  }
});
